import { FormattedMessage } from 'react-intl';

const getStatusTitle = (status: string) => {
  if (status === 'online') {
    return (
      <FormattedMessage defaultMessage="Online" id="ym4jgK" description="Cars: list group: title" />
    );
  }

  if (status === 'busy') {
    return (
      <FormattedMessage defaultMessage="Busy" id="y6ZU1J" description="Cars: list group: title" />
    );
  }

  return (
    <FormattedMessage defaultMessage="Offline" id="QdCKom" description="Cars: list group: title" />
  );
};

export { getStatusTitle };
